import toMap from '~/misc/toMap';

export default toMap([
  'ADMIN_ACCOUNT_INFO',
  'ACCOUNT_LIST',
  'USER_ROLE_CHANGE_VALUE',
  'SAVE_USER_ROLE_CHANGE',

  'DELETE_ACCOUNT_USER',
  'ADD_ACCOUNT_USER',
  'DELETE_ACCOUNT_USER_AND_GET_NEW_LIST',
  'ADD_ACCOUNT_USER_AND_GET_NEW_LIST',
  'CHANGE_ROLE_AND_GET_USER_INFO',

  'ASYNG_ERROR_HIDE',

  'ACCOUNT_INFO_INIT',
]);



// WEBPACK FOOTER //
// ./src/modules/adminAccountPage/types.js